import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import StudentPlacementHistory from "../../Staffrecord/Editform/StudentPlacementHistory";
import Select from "react-select";

const PlacementTab = ({ formData, onFormDataChange, canUpdateVerification }) => {
    console.log(
        "UI Value:",
        formData?.placementStatusChangedBy,
        formData?.placementStatusChangedAt
    );

    const [placementOfficers, setPlacementOfficers] = useState([]);

    useEffect(() => {
        const fetchPlacementOfficers = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/employees`);
                setPlacementOfficers(res.data);
            } catch (err) {
                console.error("Error fetching placement officers:", err);
            }
        };
        fetchPlacementOfficers();
    }, []);

    useEffect(() => {
        if (placementOfficers.length > 0 && formData.placedBy && !formData.placedByMode) {
            onFormDataChange((prev) => {
                const pb = prev.placedBy || "";
                let pbMode = "";

                if (pb === "Self (Student)") {
                    pbMode = "Self (Student)";
                } else if (placementOfficers.includes(pb)) {
                    pbMode = pb;
                } else if (pb.trim() !== "") {
                    pbMode = "Others";
                }

                return { ...prev, placedByMode: pbMode };
            });
        }
    }, [placementOfficers]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        onFormDataChange((prev) => {
            let updated = { ...prev };

            // Popups related to placement status
            if (
                name === "placementStatus" &&
                (value === "Placed" || value === "Placed but not accepted the Offer")
            ) {
                Swal.fire({
                    title: "Are you sure?",
                    text: "Once marked as PLACED, the candidate cannot get further placement opportunities.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Yes, continue",
                }).then((result) => {
                    if (result.isConfirmed) {
                        onFormDataChange((prev) => ({
                            ...prev,
                            placementStatus: value,
                            readyForPlacement: "Yes"
                        }));
                    }
                });

                return prev;
            }

            if (name === "placementStatus" && prev.placementStatus === "Placed" && value === "Awaiting for placement") {
                Swal.fire({
                    title: "Are you sure?",
                    text: 'Are you sure you want to mark this student as "Awaiting Placement"? Placed details will be deleted!',
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Yes, continue",
                }).then((result) => {
                    if (result.isConfirmed) {
                        onFormDataChange((prev) => ({
                            ...prev,
                            placementStatus: "Awaiting for placement",
                            companyName: "",
                            companyLocation: "",
                            jobRole: "",
                            placedBy: "",
                            placedByMode: "",
                            joiningDate: "",
                            package: "",
                            placementDate: "",
                        }));
                    }
                });

                return prev;
            }

            // Interest logic — clear notes when High
            if (name === "placementInterest" && value === "High") {
                updated["staffRemarks"] = "";
                const el = document.querySelector("textarea[name='staffRemarks']");
                if (el) el.setCustomValidity("");
            }

            updated[name] = value;
            return updated;
        });
    };
    const isPlacedLikeStatus =
        formData.placementStatus === "Placed" ||
        formData.placementStatus === "Placed but not accepted the Offer";


    return (
        <div className="form-section">
            <div className="section-content">

                {/* Placement Status */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">Placement Status</label>
                        <select
                            name="placementStatus"
                            value={formData.placementStatus ?? "Awaiting for placement"}
                            onChange={handleChange}
                            className="input select"
                        >
                            <option value="Awaiting for placement">Awaiting for placement</option>
                            <option value="Placed">Placed</option>
                            <option value="Placed but not accepted the Offer">
                                Placed but not accepted the Offer</option>
                        </select>

                        {/* ✅ MOVED INSIDE form-group, right below the select */}
                        {formData.placementStatusChangedBy && (
                            <div style={{
                                fontSize: '12px',
                                color: '#555',
                                marginTop: '6px',
                                backgroundColor: '#f0f4ff',
                                padding: '6px 10px',
                                borderRadius: '4px',
                                border: '1px solid #d0d8f0'
                            }}>
                                🕐 Last changed by <strong>{formData.placementStatusChangedBy}</strong>
                                {formData.placementStatusChangedAt && (
                                    <> on {new Date(formData.placementStatusChangedAt).toLocaleString('en-IN', {
                                        day: '2-digit', month: 'short', year: 'numeric',
                                        hour: '2-digit', minute: '2-digit'
                                    })}</>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Interest & Notes - ONLY WHEN NOT Placed */}
                {!isPlacedLikeStatus && (
                    <>
                        <div className="form-row">
                            <div className="form-group">
                                <label className="label">
                                    Showing Interest and Cooperating for Placement  <span className="mandatory">*</span>
                                </label>
                                <select
                                    name="placementInterest"
                                    value={formData.placementInterest || ""}
                                    onChange={handleChange}
                                    className="input select"
                                    required
                                >
                                    <option value="">Select Interest</option>
                                    <option value="High">High</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Low">Low</option>
                                    <option value="Critical">Critical</option>
                                    <option value="Non-Cooperative">Non-Cooperative</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group" style={{ width: "100%" }}>
                                <label className="label">
                                    Additional Notes
                                    {formData.placementInterest && formData.placementInterest !== "High" && (
                                        <span className="mandatory"> *</span>
                                    )}
                                </label>
                                <textarea
                                    name="staffRemarks"
                                    value={formData.staffRemarks || ""}
                                    onChange={handleChange}
                                    className="input"
                                    rows={3}
                                    required={formData.placementInterest && formData.placementInterest !== "High"}
                                    onInvalid={(e) => {
                                        if (formData.placementInterest === "Critical") {
                                            e.target.setCustomValidity(
                                                "Critical cases must include detailed explanation in Additional Notes."
                                            );
                                        } else {
                                            e.target.setCustomValidity(
                                                "Please add the reason in the ‘Additional Notes’ field explaining why the student is not showing interest or is being non-cooperative."
                                            );
                                        }
                                    }}
                                    onInput={(e) => e.target.setCustomValidity("")}
                                />
                            </div>
                        </div>
                    </>
                )}

                {/* Show additional fields only if Placed */}
                {isPlacedLikeStatus && (
                    <>
                        <div className="form-row">
                            <div className="form-group">
                                <label className="label">Company Name <span className="mandatory">*</span></label>
                                <input type="text" name="companyName"
                                    value={formData.companyName || ""}
                                    onChange={handleChange} className="input" required />
                            </div>
                            <div className="form-group">
                                <label className="label">Company Location <span className="mandatory">*</span></label>
                                <input type="text" name="companyLocation"
                                    value={formData.companyLocation || ""}
                                    onChange={handleChange} className="input" required />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label className="label">Date of Placement <span className="mandatory">*</span></label>
                                <input type="date" name="placementDate"
                                    value={formData.placementDate || ""} max={new Date().toISOString().split("T")[0]}
                                    onChange={handleChange} className="input" required />
                            </div>
                            <div className="form-group">
                                <label className="label">Job Role <span className="mandatory">*</span></label>
                                <input type="text" name="jobRole"
                                    value={formData.jobRole || ""}
                                    onChange={handleChange} className="input" required />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label className="label">Package in LPA <span className="mandatory">*</span></label>
                                <input
                                    type="number"
                                    name="package"
                                    value={formData.package === "" || formData.package === null ? "" : formData.package}
                                    onChange={(e) => {
                                        if (/^\d*$/.test(e.target.value)) handleChange(e);
                                    }}
                                    className="input"
                                    placeholder="Enter numeric values only (e.g., 300000)"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label className="label">Joining Date <span className="mandatory">*</span></label>
                                <input
                                    type="date"
                                    name="joiningDate"
                                    value={formData.joiningDate || ""}
                                    min={formData.placementDate || ""}
                                    onChange={handleChange}
                                    className="input"
                                    required
                                />

                            </div>
                        </div>
                        {/* Placed By Dropdown */}
                        {/* Placed By Searchable Dropdown */}
                        <div className="form-row">
                            <div className="form-group" style={{ flex: 1 }}>
                                <label className="label">
                                    Placed By <span className="mandatory">*</span>
                                </label>

                                <Select
                                    options={[
                                        { value: "Self (Student)", label: "Self (Student)" },
                                        ...placementOfficers.map((name) => ({
                                            value: name,
                                            label: name,
                                        })),
                                    ]}
                                    value={
                                        formData.placedBy
                                            ? {
                                                value: formData.placedBy,
                                                label: formData.placedBy,
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        onFormDataChange((prev) => ({
                                            ...prev,
                                            placedBy: selectedOption?.value || "",
                                            placedByMode: selectedOption?.value || "",
                                        }));
                                    }}
                                    placeholder="Search and select employee..."
                                    isClearable
                                    classNamePrefix="react-select"
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group" style={{ width: "100%" }}>
                                <label className="label">
                                    Placement Remarks
                                    {formData.placementStatus === "Placed but not accepted the Offer" && (
                                        <span className="mandatory"> *</span>
                                    )}
                                </label>

                                <textarea
                                    name="placementRemarks"
                                    value={formData.placementRemarks || ""}
                                    onChange={handleChange}
                                    className="input"
                                    rows={3}
                                    required={formData.placementStatus === "Placed but not accepted the Offer"}
                                    placeholder={
                                        formData.placementStatus === "Placed but not accepted the Offer"
                                            ? "Mention why the offer was not accepted"
                                            : "Optional remarks (if any)"
                                    }
                                    onInvalid={(e) => {
                                        if (formData.placementStatus === "Placed but not accepted the Offer") {
                                            e.target.setCustomValidity(
                                                "Placement remarks are mandatory when the offer is not accepted."
                                            );
                                        }
                                    }}
                                    onInput={(e) => e.target.setCustomValidity("")}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label className="label">Verification Status</label>

                                {canUpdateVerification ? (
                                    <select
                                        name="joiningStatus"
                                        value={formData.joiningStatus || ""}
                                        onChange={handleChange}
                                        className="input select"
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Verified">Verified</option>
                                        <option value="Incorrect Data">Incorrect Data</option>
                                        <option value="Not Responding">Not Responding</option>
                                    </select>
                                ) : (
                                    <input
                                        type="text"
                                        className="input"
                                        value={formData.joiningStatus || "-"}
                                        readOnly
                                    />
                                )}
                            </div>
                            <div className="form-group" style={{ width: "100%" }}>
                                <label className="label">Verification Remarks</label>

                                {canUpdateVerification ? (
                                    <textarea
                                        name="verificationRemarks"
                                        value={formData.verificationRemarks || ""}
                                        onChange={handleChange}
                                        className="input"
                                        rows={3}
                                    />
                                ) : (
                                    <textarea
                                        value={formData.verificationRemarks || ""}
                                        className="input"
                                        rows={3}
                                        readOnly
                                    />
                                )}
                            </div>
                        </div>
                        {formData.placementStatus === "Placed" && (
                            <>
                                <div className="form-row" style={{ marginTop: '20px', borderTop: '2px solid #e0e0e0', paddingTop: '20px' }}>
                                    <h3 style={{ width: '100%', marginBottom: '15px', color: '#333' }}>Placement Reviews</h3>
                                </div>

                                {/* Photo Review */}
                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="label">Photo Review</label>
                                        <select
                                            name="photoReview"
                                            value={formData.photoReview || ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                onFormDataChange((prev) => ({
                                                    ...prev,
                                                    photoReview: value,
                                                    photoReviewLink: value === "No" ? "" : prev.photoReviewLink || "",
                                                    photoReviewReason: value === "Yes" ? "" : prev.photoReviewReason || "",
                                                }));
                                            }}
                                            className="input select"
                                        >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">Not Possible to get the review</option>
                                        </select>
                                    </div>

                                    {formData.photoReview === "Yes" && (
                                        <div className="form-group">
                                            <label className="label">Link (Photo)</label>

                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <input
                                                    type="text"
                                                    name="photoReviewLink"
                                                    value={formData.photoReviewLink || ""}
                                                    onChange={handleChange}
                                                    className="input"
                                                    placeholder="Update the link of the photo uploaded in google drive"
                                                    required
                                                />

                                                <button
                                                    type="button"
                                                    className="gdrive"
                                                    onClick={() =>
                                                        window.open(
                                                            "https://drive.google.com/drive/u/0/folders/1MruWa1V8tEeFbqm880JxFXJ-zlw3hR5i",
                                                            "_blank"
                                                        )
                                                    }
                                                >
                                                    Google Drive
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {formData.photoReview === "No" && (
                                        <div className="form-group">
                                            <label className="label">Reason for No Photo Review</label>
                                            <input
                                                type="text"
                                                name="photoReviewReason"
                                                value={formData.photoReviewReason || ""}
                                                onChange={handleChange}
                                                className="input"
                                                placeholder="Enter the Reason why it is not possible to get the review"
                                                required
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* Video Review */}
                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="label">Video Review</label>
                                        <select
                                            name="videoReview"
                                            value={formData.videoReview || ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                onFormDataChange((prev) => ({
                                                    ...prev,
                                                    videoReview: value,
                                                    videoReviewLink: value === "No" ? "" : prev.videoReviewLink || "",
                                                    videoReviewReason: value === "Yes" ? "" : prev.videoReviewReason || "",
                                                }));
                                            }}
                                            className="input select"
                                        >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">Not Possible to get the review</option>
                                        </select>
                                    </div>

                                    {formData.videoReview === "Yes" && (
                                        <div className="form-group">
                                            <label className="label">Link (Video)</label>

                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <input
                                                    type="text"
                                                    name="videoReviewLink"
                                                    value={formData.videoReviewLink || ""}
                                                    onChange={handleChange}
                                                    className="input"
                                                    placeholder="Update the link of the video uploaded in google drive"
                                                    required
                                                />

                                                <button
                                                    type="button"
                                                    className="gdrive"
                                                    onClick={() =>
                                                        window.open(
                                                            "https://drive.google.com/drive/u/0/folders/1MruWa1V8tEeFbqm880JxFXJ-zlw3hR5i",
                                                            "_blank"
                                                        )
                                                    }
                                                >
                                                    Google Drive
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {formData.videoReview === "No" && (
                                        <div className="form-group">
                                            <label className="label">Reason for No Video Review</label>
                                            <input
                                                type="text"
                                                name="videoReviewReason"
                                                value={formData.videoReviewReason || ""}
                                                onChange={handleChange}
                                                className="input"
                                                placeholder="Enter the Reason why it is not possible to get the review"
                                                required
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* Google Review */}
                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="label">Google Review</label>
                                        <select
                                            name="googleReview"
                                            value={formData.googleReview || ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                onFormDataChange((prev) => ({
                                                    ...prev,
                                                    googleReview: value,
                                                    googleReviewStars: value === "No" ? "" : prev.googleReviewStars || "",
                                                    googleReviewReason: value === "Yes" ? "" : prev.googleReviewReason || "",
                                                }));
                                            }}
                                            className="input select"
                                        >
                                            <option value="">Select</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">Not Possible to get the review</option>
                                        </select>
                                    </div>

                                    {formData.googleReview === "Yes" && (
                                        <div className="form-group">
                                            <label className="label">Rating (Stars)</label>
                                            <div className="star-rating">
                                                {[...Array(5)].map((_, starIndex) => {
                                                    const value = starIndex + 1;
                                                    return (
                                                        <span
                                                            key={value}
                                                            className={`star ${value <= (formData.googleReviewStars || 0) ? "filled" : ""
                                                                }`}
                                                            onClick={() =>
                                                                onFormDataChange((prev) => ({
                                                                    ...prev,
                                                                    googleReviewStars: value,
                                                                }))
                                                            }
                                                            style={{ cursor: "pointer", fontSize: "30px" }}
                                                        >
                                                            ★
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                            <input
                                                type="hidden"
                                                value={formData.googleReviewStars || ""}
                                                required
                                            />
                                        </div>
                                    )}

                                    {formData.googleReview === "No" && (
                                        <div className="form-group">
                                            <label className="label">Reason for No Google Review</label>
                                            <input
                                                type="text"
                                                name="googleReviewReason"
                                                value={formData.googleReviewReason || ""}
                                                onChange={handleChange}
                                                className="input"
                                                placeholder="Enter the Reason why it is not possible to get the review"
                                                required
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
            {formData.studentId && (
                <StudentPlacementHistory studentId={formData.studentId} />
            )}
        </div>
    );
};

export default PlacementTab;
